export default {
   "orcode": "",
   "ordesc": "",
}
